import {
  CalHeatMap
} from './cal-heatmap';

require('./heatmap.component.scss');

function HeatmapController(
  $scope,
  $element,
  RouterService,
  LayoutService,
  $timeout,
  rx,
) {
  this.renderDebounce = 100;
  $scope.$element = $element;
  this.$timeout = $timeout;
  $scope.isResizeBeforePrint = false;
  $scope.router = RouterService;
  let noRender = false;
  const subscriptions = [
    rx.Observable.merge(
      $scope.$eventToObservable('resizeBeforePrint'),
      $scope.$eventToObservable('beforePrint'),
      $scope.$eventToObservable('afterPrint'),
    ).subscribe(event => {
      if (event.name === 'beforePrint' && noRender) return false;
      if (event.name === 'resizeBeforePrint' ||
        ('beforePrint' && !noRender)) noRender = true;
      if (event.name === 'afterPrint') {
        this.$timeout(() => noRender = false, 200);
        return false;
      }
      $scope.isResizeBeforePrint = event.name === 'resizeBeforePrint';
      if (!$scope.router.pdf) $scope.render(event.name);
    }),
    rx.Observable.merge(
      $scope.$eventToObservable('dashboardResize'),
      $scope.$eventToObservable('resize'),
      $scope.$eventToObservable('splitter1Changed'),
    ).debounce(this.renderDebounce) /*.debounce(100)*/
    .subscribe(event => {
      $scope.isResizeBeforePrint = false;
      if (!LayoutService.isPrint) $scope.render();
    }),
  ];


  $scope.stump = function(cell) {
    const activity = $scope.activity;
    if (!activity) return;
    const days = activity.filter.days;
    if (!cell) return new Date();
    return new Date(
      cell['agent_time.year'],
      cell['agent_time.month'] - 1,
      cell['agent_time.day'],
      cell['agent_time.hour'],
      (days === 1) ? cell['agent_time.minute'] : 0,
    );
  };
  $scope.parser = function(cells) {
    const stats = {};
    for (const i in cells) {
      const cell = cells[i];
      const at = cell['activity_time_sum'];
      const it = cell['idle_time_sum'];
      const rc = cell['record_count'];
      const st = String($scope.stump(cell).getTime() / 1000);
      stats[st] = rc;
    }
    return stats;
  };
  $scope.data = function() {
    return $scope.parser($scope.activity.cells);
  };
  $scope.getScales = function() {
    const max = Math.max(...Object.values($scope.data()));
    return Array.from(new Array(10), (val, index) => max >= 10 ? (index + 1) * Math.floor(max / 10) : index);
  };
  $scope.initLegend = function() {
    const repLegendId = '#' + this.repLegendId;
    $(repLegendId).empty();
    const scale = $scope.getScales();
    $.each(scale, function(i, item) {
      let text = item;
      if (i == scale.length - 1) {
        text = `> ${item}`;
      }
      $(repLegendId).append($('<div class="legend-item">' + text + '</div>'));
    });
  };
  $scope.render = function(evName) {
    // $scope.router.waitSeconds(2);
    // console.log('рендю! - ', evName);
    if ($scope.router.pdf) {
      if ($scope.router.CurrentFilterService.filter.isDashboard) $element.parent().width(722);
      else $element.parent().width(1090);
    }
    // $element.text('width=' + $element.parent().width());
    if (!$('#' + this.repId).length) $element.append($('<div id="' + this.repId + '" class="report-canvas"></div>'));
    if (!$('#' + this.repLegendId).length) $element.append($('<div id="' + this.repLegendId + '" class="report-canvas-legend"></div>'));
    $element.find('svg').remove();
    const calendar = new CalHeatMap($scope.$element[0]);
    const activity = $scope.activity;
    if (!activity) return;
    const days = activity.filter.days;
    $('#' + this.repId).empty();
    const data = $scope.data();
    const scale = $scope.getScales();
    const displayLegend = false;

    const isSelected = d => {
      if (!calendar.options.selectTimeFrom || !calendar.options.selectTimeTo) return false;
      const d1 = calendar.options.selectTimeFrom.getTime();
      const d2 = calendar.options.selectTimeTo.getTime();
      if (d1 < d2) return d >= d1 && d <= d2;
      return d >= d2 && d <= d1;
    };

    calendar.utsDate = d => {
      const date = new Date(d);
      return date;
      // return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(),
      //   date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
    };

    calendar.selectRects = () => {
      const rects = $element[0].querySelectorAll('rect.graph-rect');
      rects.forEach(r => {
        if (r.__data__ && r.__data__.t && isSelected(r.__data__.t)) {
          r.classList.add('selected');
        } else {
          r.classList.remove('selected');
        }
      });
    };

    if (days === 1) {
      const startDate = activity.filter.timeFrom;
      //let startDate = stump( aggregate.cells[ 0 ] );
      //startDate = new Date( startDate.getTime() - 1000 * 60 * 60 * 24 );
      const cellSize = Math.round(($element.parent().width() - 50) / 61) - 1;
      if (cellSize < 2) return;
      $('.hours').hide();
      calendar.init({
        itemSelector: '#' + this.repId,
        scale: scale,
        legend: scale,
        data: data,
        start: startDate,
        range: 24,
        colLimit: 60,
        cellSize: cellSize,
        cellPadding: 1,
        tooltip: true,
        domain: 'hour',
        subDomain: 'min',
        browsing: true,
        verticalOrientation: true,
        displayLegend,
        selectTimeFrom: null,
        selectTimeTo: null,
        onMousedown: now => {
          // console.log(now, calendar, $scope);
          calendar.options.selectTimeFrom = now;
        },
        onMouseup: function(now, count) {
          $scope.$apply(function() {
            if (!calendar.options.selectTimeFrom || calendar.options.selectTimeFrom.getTime() === now.getTime()) {
              $scope.router.addTimeFilter(now, 5, true); // Add time filter with 4 levels
            } else {
              if (calendar.options.selectTimeFrom < calendar.options.selectTimeTo) {
                $scope.router.timeFrom = calendar.utsDate(calendar.options.selectTimeFrom.setSeconds(0, 0));
                $scope.router.timeTo = calendar.utsDate(calendar.options.selectTimeTo.setSeconds(59, 999));
              } else {
                $scope.router.timeFrom = calendar.utsDate(calendar.options.selectTimeTo.setSeconds(0, 0));
                $scope.router.timeTo = calendar.utsDate(calendar.options.selectTimeFrom.setSeconds(59, 999));
              }
            }
            $scope.router.mode = 'explore';
            $scope.filterBar.setDrilldown(
              'agent_eventtype@default:agent_eventtype');
            $scope.$emit('reload');
          });
        },
      });
    } else {
      let startDate = activity.filter.timeFrom;
      if (typeof startDate === 'string' &&
        startDate.match(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}/)) {
        startDate = new Date(startDate);
      }
      const cellSize = Math.round(($element.parent().width() - 50) / 24);
      if (cellSize < 10) return;
      $('.hours').show();
      $('.hours').find('span').width(cellSize - 2);
      // Limit memory usage
      calendar.init({
        itemSelector: '#' + this.repId,
        scale: scale,
        legend: scale,
        data: data,
        start: startDate,
        range: days, // Number of days to display
        cellSize: (cellSize - 4),
        cellPadding: 2,
        colLimit: 24,
        domainMargin: [0, 0, 0, 0],
        verticalOrientation: true,
        reverse: true,
        tooltip: true,
        domain: 'day',
        subDomain: 'hour',
        browsing: true,
        displayLegend,
        selectTimeFrom: null,
        selectTimeTo: null,
        onMousedown: (now) => {
          // console.log(now, calendar, $scope);
          calendar.options.selectTimeFrom = now;
        },
        onMouseup: function(now, count) {
          // console.log(calendar.options.selectTimeFrom);
          // console.log(now, count);
          // return;
          $scope.$apply(function() {
            if (!calendar.options.selectTimeFrom || calendar.options.selectTimeFrom.getTime() === now.getTime()) {
              $scope.router.addTimeFilter(now, 4, true); // Add time filter with 4 levels
            } else {

              if (calendar.options.selectTimeFrom < calendar.options.selectTimeTo) {
                $scope.router.timeFrom = calendar.utsDate(calendar.options.selectTimeFrom.setMinutes(0, 0, 0));
                $scope.router.timeTo = calendar.utsDate(calendar.options.selectTimeTo.setMinutes(59, 59, 999));
              } else {
                $scope.router.timeFrom = calendar.utsDate(calendar.options.selectTimeTo.setMinutes(0, 0, 0));
                $scope.router.timeTo = calendar.utsDate(calendar.options.selectTimeFrom.setMinutes(59, 59, 999));
              }
            }
            $scope.router.mode = 'explore';
            $scope.filterBar.setDrilldown(
              'agent_eventtype@default:agent_eventtype');
          });
        },
      });
    }
    $scope.initLegend();
    $('.report-time').removeClass('ng-hide');

    if ($scope.isResizeBeforePrint) {
      this.$element.ready(() => {
        $timeout(() => {
          const updateElement = function(el) {
            const style = getComputedStyle(this);
            let color;
            if (style.fill !== 'rgb(0, 0, 0)') color = style.fill;
            else if (style.backgroundColor !== 'rgb(0, 0, 0)') color = style.backgroundColor;
            if (color) {
              this.style.fill = color;
              this.style.backgroundColor = color;
            }
          };
          this.$element.find('svg').each(updateElement);
          this.$element.find('text').each(updateElement);
          this.$element.find('g > rect').each(updateElement);
          $timeout(() => {
            this.$root.$broadcast('elementResized');
          }, 1000);
        }, 200);
      });
    }
  };

  $scope.$watch('activity', function() {
    $scope.render();
  });
}

export function HeatmapComponent() {
  return {
    restrict: 'E',
    template: require('./heatmap.component.html'),
    scope: {
      filter: '<',
      filterBar: '<',
      activity: '<',
      repId: '<',
      repLegendId: '<',
    },

    controller: HeatmapController,
  };
}



// WEBPACK FOOTER //
// ./src/facts/heatmap/heatmap.component.js